<script setup lang="ts">
import {useStore} from "vuex";
import Room from "@/models/Room";
import Stay from "@/models/Stay";
import Customer from "@/models/Customer";

const store = useStore();
const baseUri = process.env.VUE_APP_API_ASSET_URL;
const room:Room = store.getters['room/getRoomChoose']
const stay:Stay = store.getters['booking/getStay']
const customer:Customer =store.getters['booking/getCustomer']
</script>

<template>
  <div class="uk-flex uk-flex-column ">
    <div class="uk-card uk-card-default uk-grid-collapse uk-child-width-1-2@s uk-margin" uk-grid>
      <div class="uk-card-media-left uk-cover-container">
        <img :src="room?.room_photos ?  baseUri+room.room_photos[0] : ''" alt="room" uk-cover>
        <canvas width="500" height="200"></canvas>
      </div>
      <div class="uk-card-body">
        <h3 class="uk-card-title">Appartement</h3>

        <div class="uk-flex uk-flex-column uk-align-left@l uk-margin-left">
          <p>Numéro: <span class="uk-text-bold ">{{ room.room_name }}</span></p>
          <p>Nuitée: <span class="uk-text-bold">{{room.room_total_price}} FCFA</span></p>

        </div>
        <div class="uk-flex uk-flex-column uk-align-left@l uk-margin-left">
          <p>Type: <span class="uk-text-bold ">{{room.room_type.room_type_name}}</span></p>
          <p>Invité(s): <span class="uk-text-bold">{{stay.stays_number_of_occupants}} personne(s)</span></p>

        </div>
        <div class="uk-flex uk-flex-column uk-align-left@l uk-margin-left">
          <p>Enfant(s): <span class="uk-text-bold">{{stay.stays_number_of_children}} enfant(s)</span></p>
        </div>
      </div>

    </div>
    <div class="uk-card uk-card-default uk-card-body uk-width-1-1 uk-margin">
      <h3 class="uk-card-title">Séjour</h3>
      <div class="uk-grid-medium uk-child-width-expand@s uk-text-center" uk-grid>
        <div>
          <div class="uk-flex uk-flex-column  uk-margin-left ">
            <p>Entrée: <span class="uk-text-bold ">{{stay.stays_enter_date}}</span></p>
            <p>Sortir: <span class="uk-text-bold uk-margin-remove">{{stay.stays_leaving_date}}</span></p>
          </div>
        </div>
        <div>
          <div class="uk-flex uk-flex-column  uk-margin-left ">
            <p>Nombre de nuitée: <span class="uk-text-bold ">{{stay.stays_number_of_days}}</span></p>
            <p>Prix du séjour: <span class="uk-text-bold uk-margin-remove">{{stay.stays_total_price_to_pay}} FCFA</span></p>
          </div>
        </div>
        <div>
<!--          <div class="uk-flex uk-flex-column  uk-margin-left ">-->
<!--            <p>Réduction: <span class="uk-text-bold ">0 FCFA</span></p>-->
<!--            <p>Montant : <span class="uk-text-bold uk-margin-remove">3 pièces VIP</span></p>-->
<!--          </div>-->
        </div>
        <div>
          <div class="uk-flex uk-flex-column  uk-margin-left">
            <p>Type de séjour: <span class="uk-text-bold ">{{stay.stay_type?.stay_typ_name}}</span></p>
            <p>Mode de paiement: <span class="uk-text-bold ">{{stay.pay_mode}}</span></p>
          </div>
        </div>
      </div>
      <div class="uk-flex uk-flex-column  uk-margin-left">
        <h5>Note/Préférence</h5>
        <p class="uk-text-bold uk-text-break">
          {{stay.stays_preference}}
        </p>
      </div>
    </div>
    <div class="uk-card uk-card-default uk-card-body uk-width-1-1 uk-margin">
      <h3 class="uk-card-title">Informations personnels</h3>
      <div class="uk-grid-medium uk-child-width-expand@s uk-text-center" uk-grid>
        <div>
          <div class="uk-flex uk-flex-column  uk-margin-left ">
            <p>Civilité: <span class="uk-text-bold ">{{customer.cust_sexe}}</span></p>
            <p>Nom: <span class="uk-text-bold uk-margin-remove">{{customer.cust_lastname}}</span></p>
          </div>
        </div>
        <div>
          <div class="uk-flex uk-flex-column  uk-margin-left ">
            <p>Prénom: <span class="uk-text-bold ">{{customer.cust_firstname}}</span></p>
            <p>Date d'anniversaire: <span class="uk-text-bold uk-margin-remove">{{customer.cust_birthday}}</span></p>
          </div>
        </div>
        <div>
          <div class="uk-flex uk-flex-column  uk-margin-left ">
            <p>Type de pièce d'identité: <span class="uk-text-bold ">{{customer.cust_type_id}}</span></p>
            <p>Réference de la pièce: <span class="uk-text-bold uk-margin-remove">{{customer.cust_reference_id}}</span></p>
          </div>
        </div>

      </div>
      <div class="uk-grid-medium uk-child-width-expand@s uk-text-center" uk-grid>
        <div>
          <div class="uk-flex uk-flex-column  uk-margin-left ">
            <p>Contact: <span class="uk-text-bold ">{{customer.cust_contact}}</span></p>
            <p>Lieu de residence: <span class="uk-text-bold uk-margin-remove">{{customer.cust_place_residence}}</span></p>
          </div>
        </div>
        <div>
          <div class="uk-flex uk-flex-column  uk-margin-left ">
            <p>Email: <span class="uk-text-bold ">{{customer.cust_email}}</span></p>
            <p>Profession: <span class="uk-text-bold uk-margin-remove">{{customer.cust_job}}</span></p>
          </div>
        </div>
        <div>
          <div class="uk-flex uk-flex-column  uk-margin-left ">
            <p>Pays: <span class="uk-text-bold ">{{customer.cust_country}}</span></p>
            <p>Ville: <span class="uk-text-bold uk-margin-remove">{{customer.cust_city}}</span></p>
          </div>
        </div>

      </div>
      <div class="uk-grid-medium uk-child-width-expand@s uk-text-center" uk-grid>
        <div>
          <div class="uk-flex uk-flex-column  uk-margin-left ">
            <p>Nationalité: <span class="uk-text-bold ">{{customer.cust_nationality}}</span></p>
          </div>
        </div>
<!--        <div>-->
<!--          <div class="uk-flex uk-flex-column  uk-margin-left ">-->
<!--            <p>Entrée: <span class="uk-text-bold ">02/10/2023</span></p>-->
<!--            <p>Sortir: <span class="uk-text-bold uk-margin-remove">05/10/2023</span></p>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div>-->
<!--          <div class="uk-flex uk-flex-column  uk-margin-left ">-->
<!--            <p>Entrée: <span class="uk-text-bold ">02/10/2023</span></p>-->
<!--            <p>Sortir: <span class="uk-text-bold uk-margin-remove">05/10/2023</span></p>-->
<!--          </div>-->
<!--        </div>-->

      </div>

    </div>

  </div>
</template>

<style scoped>

</style>